export function LoginSuccess() {
  return {
    title: `Login Success`,
    status: 'success',
    isClosable: true,
    position: 'top-right',
    duration: '1500',
  };
}

export function GenSuccess(message) {
  return {
    title: message || 'success',
    status: 'success',
    isClosable: true,
    position: 'top-right',
    duration: '1500',
  };
}

export function UploadSuccess() {
  return {
    title: `File uploaded successfully`,
    status: 'success',
    isClosable: true,
    position: 'top-right',
    duration: '1500',
  };
}

export function LoginFail() {
  return {
    title: `Login Failed`,
    status: 'error',
    isClosable: true,
    position: 'top-right',
    duration: '2000',
  };
}

export function GenError_login_Change(message) {
  return {
    title: message,
    status: 'info',
    isClosable: true,
    position: 'top-right',
    duration: '4000',
  };
}

export function GenError(message) {
  return {
    title: message || 'error',
    status: 'error',
    isClosable: true,
    position: 'top-right',
    duration: '4000',
  };
}

export function TostError(message) {
  return {
    title: message || 'error',
    status: 'error',
    isClosable: true,
    position: 'top-right',
    duration: '4000',
  };
}

export function Error(message) {
  return {
    title: message,
    status: 'info',
    isClosable: true,
    position: 'top-right',
    duration: '4000',
  };
}
